import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: ErrorState = {
  message: '',
  show: false,
  redirectPath: undefined
}

interface SetErrorPayload {
  message: string
  redirectPath?: string
}

export const errorSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setError: (
      state,
      action: PayloadAction<string | SetErrorPayload | undefined>
    ): void => {
      if (typeof action.payload === 'string' || !action.payload) {
        state.message = action.payload ?? ''
        state.show = true
        state.redirectPath = undefined
      } else {
        state.message = action.payload.message ?? ''
        state.show = true
        state.redirectPath = action.payload.redirectPath
      }
    },
    cleanError: (state): void => {
      state.show = false
      state.redirectPath = undefined
    }
  }
})

export const { setError, cleanError } = errorSlice.actions
export const errorReducer = errorSlice.reducer
